import { api } from "../axios";

export const API_BASE = {
    getBaseInfo: async <T>() => {
        const { data } = await api.get<T>("/t_basic_info_p.php");

        return data.result;
    },
};

export const API_COMMON = {
    getCommonInfo: async <T>(params?: { [key: string]: string }) => {
        const { data } = await api.get<T>("/t_common_info.php", { ...params });

        return data.result;
    },
};

export const API_LOCATION = {
    getMapInfo: async <T>(params?: { [key: string]: string }) => {
        const { data } = await api.get<T>("/t_way.php", { ...params });

        return data.result;
    },
};

export const API_ROOMS = {
    getRoomInfo: async <T>(params?: { [key: string]: string }) => {
        const { data } = await api.get<T>("/t_room_info_p.php", { ...params, page: "rooms" });

        return data.result;
    },
};

export const API_GUIDE = {
    getGuideInfo: async <T>(params?: { [key: string]: string }) => {
        const { data } = await api.get<T>("/t_guide_info.php", { ...params, page: "notice" });

        return data.result;
    },
};

export const API_RESERVE = {
    getReserveRoomInfo: async <T>(params?: { [key: string]: string | number }) => {
        const { data } = await api.get<T>("/t_reserv_info.php", { ...params });

        return data.result;
    },
};

export const API_SPECIAL = {
    getSpecialInfo: async <T>(params?: { [key: string]: string }) => {
        const { data } = await api.get<T>("/t_special_info.php", { ...params, page: "specials" });

        return data.result;
    },
};

export const API_POP_UP = {
    getPopUpInfo: async <T>() => {
        const { data } = await api.get<T>("/t_pop_info.php");

        return data.result;
    },
};
